import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { navigate, Link } from 'gatsby';
import Dropdown from './dropdown';

const SubMenuStyled = styled.div`
	position: relative;
	margin: 0em 0.7em;
	font-size: var(--font-size-base);
	align-self: center;

	.openArrow {
		background: #f1f1f1;
		border-top-left-radius: 2px;
		bottom: -8px;
		height: 16px;
		left: 50%;
		position: absolute;
		-webkit-transform: translateX(calc(-50% - 10px)) rotate(45deg);
		transform: translateX(calc(-50% - 10px)) rotate(45deg);
		width: 16px;
	}

	.menuButton {
		align-items: center;
		border-radius: 4px;
		color: #fff;
		cursor: pointer;
		display: inline-flex;
		font-size: var(--font-size-base);
		padding: 10px 0px;
		position: relative;
		text-decoration: none;
	}

	.menuButton:hover {
		background-color: #ffffff0d;
		text-decoration: underline;
		color: var(--link_color);
	}

	.menuButton1 {
		background: transparent;
		border: 0;
		color: var(--secondary_6);
		font-family: inherit;
		font-size: var(--font-size-base);
	}
	.menuButton2 {
		white-space: nowrap;
	}

	// mobile settings
	@media (max-width: 1199.5px) {
		margin-left: 0px;
		border-bottom: 1px solid #ccc !important;
		border-radius: 0px;
		align-self: auto;
		position: relative;
		z-index: 1000;

		.menuButton {
			font-weight: 600;
			font-size: var(--font-size-base);
			/* padding: 10px 0px; */
		}
		.openArrow {
			display: none;
		}
		.accordianArrow {
			margin-left: 0.5em;
		}
		.accordianArrowClose {
			transform: rotate(180deg);
		}
	}
	// mobile settings
	@media (max-width: 768px) {
		border-bottom: 1px solid #ccc !important;
		border-radius: 0px;
		padding: 10px 0px;
		width: 100%;
		position: relative;
		z-index: 1000;
	}
`;
export default function SubMenu(props) {
	const { menuItem } = props;
	const [dropdown, setDropdown] = useState(false);
	const [hoverTimeout, setHoverTimeout] = useState(null);
	const [isClient, setIsClient] = useState(false);
	//for detecting clicks outside of the dropdown
	let ref = useRef();

	// Check if we're on the client side
	useEffect(() => {
		setIsClient(true);
	}, []);

	// detect clicks outside of the dropdown
	useEffect(() => {
		const handler = (event) => {
			if (dropdown && ref.current && !ref.current.contains(event.target)) {
				setDropdown(false);
			}
		};
		document.addEventListener('mousedown', handler);
		document.addEventListener('touchstart', handler);
		return () => {
			// Cleanup the event listener
			document.removeEventListener('mousedown', handler);
			document.removeEventListener('touchstart', handler);
		};
	}, [dropdown]);

	// Handle hover events (desktop only)
	const handleMouseEnter = () => {
		// Only handle hover on desktop screens
		if (isClient && window.innerWidth > 1199.5) {
			// Clear any existing timeout
			if (hoverTimeout) {
				clearTimeout(hoverTimeout);
				setHoverTimeout(null);
			}
			setDropdown(true);
		}
	};

	const handleMouseLeave = () => {
		// Only handle hover on desktop screens
		if (isClient && window.innerWidth > 1199.5) {
			// Set a timeout to close the dropdown after a short delay
			const timeout = setTimeout(() => {
				setDropdown(false);
			}, 300); // 300ms delay
			setHoverTimeout(timeout);
		}
	};

	// Handle click events
	const handleClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		// Clear any hover timeout when clicking
		if (hoverTimeout) {
			clearTimeout(hoverTimeout);
			setHoverTimeout(null);
		}
		setDropdown((prev) => !prev);
	};

	// Cleanup timeout on unmount
	useEffect(() => {
		return () => {
			if (hoverTimeout) {
				clearTimeout(hoverTimeout);
			}
		};
	}, [hoverTimeout]);

	return (
		<SubMenuStyled
			ref={ref}
			onMouseEnter={
				isClient && window.innerWidth > 1199.5 ? handleMouseEnter : undefined
			}
			onMouseLeave={
				isClient && window.innerWidth > 1199.5 ? handleMouseLeave : undefined
			}
			// className='menuButton'
		>
			<button
				aria-haspopup='menu'
				aria-expanded={dropdown ? 'true' : 'false'}
				onClick={handleClick}
				className='menuButton menuButton1 menuButton2'
			>
				{menuItem.title}
				{/* arrow icon svg */}
				<svg
					stroke='currentColor'
					fill='currentColor'
					stroke-width='0'
					viewBox='0 0 24 24'
					className={
						dropdown ? 'accordianArrow accordianArrowClose' : 'accordianArrow'
					}
					height='1em'
					width='1em'
					xmlns='http://www.w3.org/2000/svg'
				>
					<path fill='none' d='M0 0h24v24H0z'></path>
					<path d='M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'></path>
				</svg>
				{dropdown && <span className='openArrow'></span>}
			</button>
			{dropdown && (
				<div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
					<Dropdown
						setDropdown={setDropdown}
						setExpanded={props.setExpanded}
						items={menuItem.items}
						dropdown={dropdown}
					/>
				</div>
			)}
		</SubMenuStyled>
	);
}
